import React, { Component } from 'react';
import { connect } from 'react-redux';
import TranslatedCopy from '../../intl/translated-copy';
import Btn from '../global/button';
import { getErrorMessage } from '../../../redux/actions/index';
import Pictogram from '../global/pictogram';

const mapStateToProps = state => ({
  errorMessageCms: state.ErrorMessage.errorMessageCms,
  errorMessageCmsFail: state.ErrorMessage.errorMessageCmsFail,
  loadingErrorMessage: state.ErrorMessage.loadingErrorMessage,
  apiError: state.Manage.apiError,
});

class ErrorNonEmissionChargeModal extends Component {
  constructor() {
    super();

    this.state = {
      hasError: false,
    };
  }

  componentWillMount() {
    const { apiError, language, dispatch } = this.props;
    if (apiError !== null) {
      dispatch(getErrorMessage(apiError.errorData.code, language));
      this.setState({
        hasError: true,
      });
    }

    const htmlTag = document.getElementsByTagName('html')[0];
    htmlTag.classList.add('Modal-open--state');
  }

  componentWillUnmount() {
    const htmlTag = document.getElementsByTagName('html')[0];
    htmlTag.classList.remove('Modal-open--state');
  }

  render() {
    const { loadingErrorMessage } = this.props;
    return (
      <div className='ErrorModal'>
        { !loadingErrorMessage ?
          <div className='Modal-Baggage'>
            <div className='Modal-Baggage__container'>
              { this.renderError() }
            </div>
          </div>
          : null }
      </div>
    );
  }

  renderError() {
    return (
      <div className='ErrorRetryModal ErrorRetryModal-emission'>
        <div className='ErrorRetryModal-main'>
          <div className='ErrorRetryModal-icon-container'>
            <Pictogram
              className='ErrorRetryModal-emission-icon'
              id='callCenter' />
            <Pictogram
              className='ErrorRetryModal-icon-warning'
              id='warningAlert'/>
          </div>
          <TranslatedCopy
            className='ErrorRetryModal-subtitle'
            copyID='MYB_NON_EMISSION_CHARGE_MODAL_EXTRAS'
            tagName='p' />
          <TranslatedCopy
            className='ErrorRetryModal-heading ErrorRetryModal-heading-emission'
            copyID='MYB_NON_EMISSION_CHARGE_MODAL_TITLE'
            tagName='h5'/>
          <TranslatedCopy
            className='ErrorRetryModal-body ErrorRetryModal-body-emission'
            copyID='MYB_NON_EMISSION_CHARGE_MODAL_MESSAGE'
            tagName='p' />
        </div>
        <div className='ModalCta ModalCta-emission'>
          <div className='ErrorRetryModal-wrapActions'>
            { this.renderCloseButton() }
          </div>
        </div>
        <button
          className='Modal-close Icon Icon--xThin'
          id='ErrorRetryModal-close'
          onClick={ () => this.closePaymentErrorModal() } />
      </div>
    );
  }

  renderCloseButton() {
    return (
      <div className='Form-submit EmailPNRInfo-saveButton'>
        <Btn
          copyID='MYB_NON_EMISSION_CHARGE_MODAL_CLOSE'
          className='ErrorRetryModal-accept'
          filledRed={ true }
          onBtnClick={ () => this.closePaymentErrorModal() }
          size='small' />
      </div>
    );
  }

  closePaymentErrorModal() {
    window.location.reload();
  }
}

ErrorNonEmissionChargeModal = connect(mapStateToProps)(ErrorNonEmissionChargeModal);

export default ErrorNonEmissionChargeModal;
